import { Geometry, Position } from 'geojson'

export const geoJsonObjectToCoordinates = (geo: Geometry): Position[] => {
  switch (geo.type) {
    case 'Point':
      return [geo.coordinates]
    case 'MultiPoint':
    case 'LineString':
      return geo.coordinates
    case 'MultiLineString':
    case 'Polygon':
      return geo.coordinates.flat()
    case 'MultiPolygon':
      return geo.coordinates.flat().flat()
    case 'GeometryCollection':
      return geo.geometries.map(geoJsonObjectToCoordinates).flat()
    // Should never be reached
    default:
      return []
  }
}

export default geoJsonObjectToCoordinates
